export default "__VITE_ASSET__DfJIGIJQ__"